<template>
    <div class="EsqueciMinhaSenha" >
        <b-modal ref="esqueci-senha" id="modalEsqueciSenha" size="lg" :hide-footer="true" :hide-header="true">
            <div class="w-100 text-end txt-size-20 txt-cores-6">
                <span @click="close"><i class="fas fa-times c-pointer" ></i></span>
            </div>
            <form class="px-3 pb-3" id="formEsqueciSenha">

                <div class="row">
                    <span class="txt-p txt-roxo-1 txt-size-25 txt-w-bold mb-2">
                        Esqueceu sua senha ?
                    </span>
                    <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                        Informe seu e-mail de login para enviarmos uma nova senha.
                    </p>
                </div>
                
                <div class="row mb-4">
                    <div class="form-group">
                        <input type="email" class="form-control" id="email" placeholder="Digite seu e-mail" v-model="email" required>
                    </div>
                </div>
                
                <div class="row">
                    <div class="form-group w-100">
                        <button class="btn btn-roxo w-100" type="button" :disabled="!validar" @click="enviar" >Enviar</button>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'EsqueciMinhaSenha',
        data: function () {
            return {
                email: null,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            validar() {
                if (this.email == '' || this.email == null) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/forgotPassword`, { login: $this.email })
                        .then(function(){
                            avisoSucesso("Sua solicitação foi registrada, verifique seu e-mail!");
                            $this.$refs['modal-esqueci-senha'].hide();
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data.msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formEsqueciSenha')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            close() {
                this.$refs['esqueci-senha'].hide();
            }
        },
        created: function () {
            
        },
        watch: {
            showModal: function () {
                this.$refs['esqueci-senha'].show();
            },
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* MODAL */
    
    .form-control {
        border: 1px solid #474747;
    }
</style>

